import React, { useState, useEffect } from "react";
import { Modal, Descriptions, Typography, Image } from "antd";
import { getBanner, ListClass } from "../../constants/API/API";
import { ShowToast, Severty } from "../../helper/toast";
import useApi from "../../hooks/useApi";

const { Title } = Typography;

const ViewBanner = ({ viewVisible, setViewVisible, selectedBelt }) => {
  const [beltData, setBeltData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  useApi({
    callback: ListClass,
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ list }) => setClasses(list),
  });

  useEffect(() => {
    if (selectedBelt) {
      setLoading(true);
      getBanner(selectedBelt._id)
        .then((response) => {
          if (response.status === 200 && response.data) {
            setBeltData(response.data);
          }
        })
        .catch((err) => {
          ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedBelt]);

  const handleCancel = () => {
    setViewVisible(false);
    setBeltData(null);
  };

  return (
    <Modal
      open={viewVisible}
      title={
        <Title level={4} style={{ margin: 0 }}>
          Banner Details
        </Title>
      }
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
      loading={loading}
    >
      {beltData && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            minWidth: "150px",
          }}
          contentStyle={{
            backgroundColor: "#fff",
          }}
        >
          <Descriptions.Item label="Branch Name">
            {beltData?.branchId?.name || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Banner Title">
            {beltData.title}
          </Descriptions.Item>
          <Descriptions.Item label="Banner Link">
            {beltData.link}
          </Descriptions.Item>
          <Descriptions.Item label="Banner Image">
            <Image src={beltData.image} alt="BannerImage" />
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default ViewBanner;
